import 'babel-polyfill';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import objectFitImages from 'object-fit-images';

import StoryAppContainer from './StoryAppContainer';
import FeaturedAppContainer from './FeaturedAppContainer';
import * as appActions from './AppActions';
import ReactGA from 'react-ga';
import './Style';

class AppContainer extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        // ReactGA.initialize('UA-798212-2');
        objectFitImages();

        window.addEventListener('message', (e) => {
            console.log('message update', e.data);
            if (e.data.update) {
                this.props.appActions.postMessageEvent(e.data.data)
            }
        })
    }

    render() {
        const { pathname } = this.props;

        if (pathname.indexOf('/featured') === -1) {
            return (<StoryAppContainer/>);
        } else {
            return (<FeaturedAppContainer/>);
        }
    }
}

AppContainer.propTypes = {
    pathname: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    return {
        pathname: state.routing.location.pathname,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        appActions: bindActionCreators(appActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)
